import Axios from "axios";

const makeZapierRequest = (payload, webhook = null) => {


    payload.date = formatTodayDate();
    payload.isoDate = getTodayIsoDate();


    window?.dataLayer?.push({ ...payload });

    const requestOptions = {
        method: "POST",
        mode: "no-cors",
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify(payload),
    };
    if (!!webhook) {
        try {
            fetch(webhook, requestOptions);
        } catch (error) {
            console.log(error)
        }
    } else {
        // console.log('webhook is empty');
    }

    // send data to wp endpoint
    Axios.post(`${process.env.GATSBY_WP_URL}/wp-json/hol/formSubmit`, { payload: payload })
        .then(result => {
            console.log(result);
        })
        .catch(err => {
            console.log("====================================")
            console.log(`Something bad happened while fetching the data\n${err}`)
            console.log("====================================")
        })

}

const formatTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const formattedToday = mm + '/' + dd + '/' + yyyy;

    return formattedToday;
}

const getTodayIsoDate = () => {
    const todayISO = new Date().toISOString();
    return todayISO;
}

export default makeZapierRequest;